import CheckEmailPage from "./CheckEmailPage";

export default CheckEmailPage;
